import { cx } from '../lib/cx';
import { Button } from './Button';

export interface ErrorStateProps {
  title: string;
  help: string;
  retryLabel?: string;
  onRetry?: () => void;
  secondaryLabel?: string;
  onSecondary?: () => void;
  className?: string;
}

/** Svaka greška kaže što se dogodilo i nudi izlaz — ARHITEKTURA.md sekcija 10. */
export function ErrorState({
  title,
  help,
  retryLabel,
  onRetry,
  secondaryLabel,
  onSecondary,
  className,
}: ErrorStateProps) {
  return (
    <div
      role="alert"
      data-testid="error-state"
      className={cx(
        'flex flex-col items-center gap-3 rounded-xl border border-line bg-surface',
        'px-6 py-10 text-center shadow-card',
        className,
      )}
    >
      <span aria-hidden="true" className="text-danger">
        <svg width="36" height="36" viewBox="0 0 36 36" fill="none">
          <circle cx="18" cy="18" r="14" stroke="currentColor" strokeWidth="1.5" />
          <path d="M18 11v9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
          <circle cx="18" cy="24.5" r="1.2" fill="currentColor" />
        </svg>
      </span>
      <h3 className="font-display text-[21px] font-semibold text-ink">{title}</h3>
      <p className="max-w-prose text-[14.5px] leading-relaxed text-ink-muted">{help}</p>
      <div className="mt-2 flex flex-wrap justify-center gap-3">
        {retryLabel && onRetry && (
          <Button size="sm" onClick={onRetry}>
            {retryLabel}
          </Button>
        )}
        {secondaryLabel && onSecondary && (
          <Button size="sm" variant="secondary" onClick={onSecondary}>
            {secondaryLabel}
          </Button>
        )}
      </div>
    </div>
  );
}
